import React, { useState } from 'react';
import './AddInvoiceComponent.css';
import { FaPlus, FaMinus } from 'react-icons/fa';
import ENDPOINTS from '../Constants/ApiEndpoints';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../UserAccounts/AuthProvider';

const invoiceNameOptions = ['Consultation', 'Follow-up', 'Lab Test'];
const invoiceDescriptionOptions = ['Initial visit', 'Post-surgery checkup', 'Blood work'];

const AddInvoiceComponent = ({ onClose, onSubmit, appointmentId, admissionId }) => {

   const { userData } = useAuth();
  const [invoices, setInvoices] = useState([
    { name: '', description: '', amount: '' }
  ]);

  const handleAddInvoiceRow = () => {
    setInvoices([...invoices, { name: '', description: '', amount: '' }]);
  };

  const handleRemoveInvoiceRow = (index) => {
    const updated = [...invoices];
    updated.splice(index, 1);
    setInvoices(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...invoices];
    updated[index][field] = value;
    setInvoices(updated);
  };

  const handleSubmit = async () => {
    const isValid = invoices.every(inv => inv.name && inv.description && parseFloat(inv.amount) > 0);
    if (!isValid) {
      toast.error('Please fill all fields correctly.');
      return;
    }
  
    const payload = invoices.map(inv => ({
      appointmentId,
      admissionId,
      invoiceName: inv.name,
      invoiceDescription: inv.description,
      totalAmount: parseFloat(inv.amount),
      addedBy:userData.username
    }));
  
    try {
      const response = await axios.post(`${ENDPOINTS.CREATE_INVOICES}`, payload);
      toast.success('Invoices created successfully!');
      onSubmit(response.data);
      onClose();
    } catch (error) {
      toast.error('Failed to create invoices. Please try again.');
      console.error(error);
    }
  };
  
  

  return (
    <div className="invoice-popup-overlay">
      <div className="invoice-popup">
        <h3>Add Invoices</h3>

        {invoices.map((inv, index) => (
          <div key={index} className="invoice-row-form">
            <select value={inv.name} onChange={(e) => handleChange(index, 'name', e.target.value)}>
              <option value="">Select Invoice Name</option>
              {invoiceNameOptions.map((opt, i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
            </select>

            <select value={inv.description} onChange={(e) => handleChange(index, 'description', e.target.value)}>
              <option value="">Select Description</option>
              {invoiceDescriptionOptions.map((opt, i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
            </select>

            <input
              type="number"
              placeholder="Amount"
              value={inv.amount}
              onChange={(e) => handleChange(index, 'amount', e.target.value)}
            />

            {index > 0 && (
              <button className="icon-btn" onClick={() => handleRemoveInvoiceRow(index)}>
                <FaMinus />
              </button>
            )}
          </div>
        ))}

        <button className="add-btn" onClick={handleAddInvoiceRow}><FaPlus /> Add More</button>

        <div className="popup-actions">
          <button onClick={handleSubmit}>Submit</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddInvoiceComponent;
